import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const ComplementaritySection = () => {
  const { t } = useLanguage();

  const employerBenefits = [
    {
      icon: "PlusCircle",
      title: t('complementarity.employerBenefit1Title'),
      description: t('complementarity.employerBenefit1Desc')
    },
    {
      icon: "Link",
      title: t('complementarity.employerBenefit2Title'),
      description: t('complementarity.employerBenefit2Desc')
    },
    {
      icon: "Handshake",
      title: t('complementarity.employerBenefit3Title'),
      description: t('complementarity.employerBenefit3Desc')
    }
  ];

  const candidateBenefits = [
    {
      icon: "Layers",
      title: t('complementarity.candidateBenefit1Title'),
      description: t('complementarity.candidateBenefit1Desc')
    },
    {
      icon: "Star",
      title: t('complementarity.candidateBenefit2Title'),
      description: t('complementarity.candidateBenefit2Desc')
    },
    {
      icon: "ShieldCheck",
      title: t('complementarity.candidateBenefit3Title'),
      description: t('complementarity.candidateBenefit3Desc')
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#0025cc]/10 backdrop-blur-xl border border-[#0025cc]/20 rounded-full mb-4 md:mb-6">
            <Icon name="GitMerge" size={20} color="#0025cc" />
            <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('complementarity.badge')}</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
            {t('complementarity.title')}
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-3xl mx-auto">
            {t('complementarity.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* For Employers */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-[#0025cc] flex items-center justify-center">
                <Icon name="Building2" size={20} color="#FFFFFF" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#111827]">
                {t('complementarity.forEmployers')}
              </h3>
            </div>
            <div className="space-y-6">
              {employerBenefits?.map((benefit, index) => (
                <div 
                  key={index}
                  className="flex gap-4 p-5 rounded-xl bg-gray-50 hover:bg-gray-100 transition-all duration-300"
                >
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 rounded-lg bg-[#0025cc]/10 flex items-center justify-center">
                      <Icon name={benefit?.icon} size={20} color="#0025cc" />
                    </div>
                  </div>
                  <div>
                    <h4 className="text-base md:text-lg font-semibold text-[#111827] mb-1">
                      {benefit?.title}
                    </h4>
                    <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">
                      {benefit?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* For Candidates */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-[#0025cc] flex items-center justify-center">
                <Icon name="User" size={20} color="#FFFFFF" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#111827]">
                {t('complementarity.forCandidates')}
              </h3>
            </div>
            <div className="space-y-6">
              {candidateBenefits?.map((benefit, index) => (
                <div 
                  key={index}
                  className="flex gap-4 p-5 rounded-xl bg-gray-50 hover:bg-gray-100 transition-all duration-300"
                >
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 rounded-lg bg-[#0025cc]/10 flex items-center justify-center">
                      <Icon name={benefit?.icon} size={20} color="#0025cc" />
                    </div>
                  </div>
                  <div>
                    <h4 className="text-base md:text-lg font-semibold text-[#111827] mb-1">
                      {benefit?.title}
                    </h4>
                    <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">
                      {benefit?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplementaritySection;